import apiFetch from 'utils/apiFetch';
import initialState from './initialState';
import { RESET_CONTEXT, LOG_OUT } from './action-types';

const LOADING = 'LOADING';
const RESET_LOADING = 'RESET_LOADING';
const RESET_STORE = 'RESET_STORE';
const SET_STEPS_WATCHED = 'SET_STEPS_WATCHED';
const SECTION_SELECTED = 'SECTION_SELECTED';

// ACTIONS
function loading(payload) {
  return {
    type: LOADING,
    payload,
  };
}

function resetLoading() {
  return {
    type: RESET_LOADING,
  };
}

function resetStore() {
  return {
    type: RESET_STORE,
  };
}

export function setStepsWatched(list) {
  return {
    type: SET_STEPS_WATCHED,
    list,
  };
}

export const getStepsWatchedAction = () => (dispatch) => {
  return apiFetch(
    'GET',
    { endPoint: 'getStepsWatched' },
  ).then(({ list }) => {
    dispatch(setStepsWatched(list));
  });
};

export const setStepsWatchedAction = name => (dispatch) => {
  return apiFetch(
    'POST',
    { endPoint: 'setStepWatched' },
    { name },
  ).then(({ success, info }) => {
    if (success) dispatch(setStepsWatched(info.list));
  });
};

// ACTION CREATORS
export function loadingAction(action) {
  return (dispatch) => {
    dispatch(loading(action));
  };
}

export function resetLoadingAction() {
  return (dispatch) => {
    dispatch(resetLoading());
  };
}

export function resetStoreAction() {
  return (dispatch) => {
    dispatch(resetStore());
  };
}

export const resetContext = () => (dispatch) => {
  dispatch({ type: RESET_CONTEXT });
};

export const logOut = () => (dispatch) => {
  apiFetch('POST', { endPoint: 'logout' });
  dispatch({ type: LOG_OUT });
};

export const setSectionSelected = selected => (dispatch) => {
  dispatch({ type: SECTION_SELECTED, payload: selected });
};
// REDUCER
export default function globalReducer(state = initialState.global, action) {
  switch (action.type) {
    case LOADING: {
      let loadingProcesses = state.loading;
      if (action.payload) {
        loadingProcesses += 1;
      } else {
        loadingProcesses -= 1;
      }

      loadingProcesses = Math.max(0, loadingProcesses);
      return {
        ...state,
        lastLoading: new Date().getTime(),
        loading: loadingProcesses,
      };
    }
    case RESET_LOADING:
      return {
        ...state,
        loading: 0,
      };
    case SET_STEPS_WATCHED:
      return {
        ...state,
        stepsWatched: action.list,
      };
    case RESET_STORE:
      return initialState;
    case SECTION_SELECTED:
      return {
        ...state,
        selected: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/globalState/global.js